import httpClient from "./httpClient";

const postApiData = async (url, body, config = {}) => {
  try {
    const response = await httpClient.post(url, body, config);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return {
      error: true,
      status: error?.response?.status,
      data: error?.response?.data,
    };
  }
};

export default postApiData;
